module.exports = __webpack_public_path__ + "static/media/diag05.c4ae53e9.jpg";